import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UserData, UserResponse } from '@/common/types/users'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

interface UseUserProps {
  id: string
  staleTime?: number
  enabled?: boolean
}

const useUser: (props: UseUserProps) => UseQueryResult<UserData, unknown> = ({ id, staleTime, enabled }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<UserResponse, unknown, UserData>({
    queryKey: ['user', id],
    queryFn: () => {
      return privateAxios.get(`/users/${id}`)
    },
    select: (data) => data?.data?.data,
    staleTime,
    enabled,
  })
}

export default useUser
